export function personalAreaNavButtonLabel(user) {
  if (!user?.id) return 'איזור אישי';
  const name = String(user.name || '').trim() || 'אורח/ת';
  return `${name}, בוקר טוב עולם, לאיזור האישי`;
}
